<template>
  <div class="sc-header"
       :class="{'rounded-top': !forceFullScreen}"
       :style="{background: colors.header.bg, color: colors.header.text, fontFamily: colors.font}"
  >
    <slot v-if="imageUrl && colors.header.logoOnly">
      <img class="sc-header--img" :src="imageUrl" alt="" height="100%"/>
    </slot>
    <slot v-else>
      <img v-if="imageUrl" class="sc-header--img border-radius-50" :src="imageUrl" alt="" height="36px" width="36px"/>
      <div v-if="!disableUserListToggle" class="sc-header--title enabled" @click="toggleUserList"> {{title}} </div>
      <div class="sc-header--title" :style="{fontSize: colors.header.fontSize, padding: colors.header.padding}" v-html="$t('welcome')"></div>
    </slot>

    <div v-if="showCloseButton" class="sc-header--close-button" @click="onClose">
      <icon-cross class="display-none display-mobile-block" :fill="colors.header.text"/>
      <icon-arrow-down class="display-block display-mobile-none" :fill="colors.header.text"/>
    </div>
  </div>
</template>
<script>

import IconCross from './icons/icons/IconCross'
import IconArrowDown from './icons/icons/IconArrowDown'

export default {
  components: { IconCross, IconArrowDown },
  props: {
    imageUrl: {
      type: String,
      default: ''
    },
    title: {
      type: String
    },
    onClose: {
      type: Function,
      required: true
    },
    colors: {
      type: Object,
      required: true
    },
    disableUserListToggle: {
      type: Boolean,
      default: false
    },
    showCloseButton: {
      type: Boolean,
      default: false
    },
    forceFullScreen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleUserList () {
      this.inUserList = !this.inUserList
      this.$emit('userList', this.inUserList)
    }
  },
  data () {
    return {
      inUserList: false
    }
  }
}
</script>
